
  import { Vue, Component, Prop } from "vue-property-decorator";

  import SearchableDocumentsList from "@/components/documents/SearchableDocumentsList.vue";
  import DocumentItem from "@/components/documents/DocumentItem.vue";
  import CardBodyItem from "@/components/card/CardBodyItem.vue";
  import UploadDocument from "@/components/documents/UploadDocumentResources.vue";
  import DocumentUserInformation from "@/components/documents/DocumentUserInformation.vue";
  import SearchOnAction from "@/components/common/SearchOnActionNew.vue";

  import RouteNames from "@/entities/RouteNames";
  import { User } from "@/generated/graphql";

  @Component({
    components: {
      SearchableDocumentsList,
      DocumentItem,
      CardBodyItem,
      UploadDocument,
      DocumentUserInformation,
      SearchOnAction,
    },
  })
  export default class AllDocumentsSearchableList extends Vue {
    @Prop({ type: String, default: undefined }) readonly companyId?: string;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    @Prop({ type: Object, default: () => ({}) }) readonly query!: Object;
    
    routeNames = RouteNames;
    searchByDocumentName: string = "";
    searchTouched: boolean = false;
  }
